<div class="arrows mb-3" #arrowsContainer>
  @for (event of events(); let index = $index; track event.status) {
    <div
      class="arrow"
      [ngClass]="{
        step1: index === 0,
        current: index === pendingEventIndex(),
        pending: !event.completed && index !== pendingEventIndex(),
        stepLast: index === events().length - 1
      }"
    >
      @if (showSendEmailButton() && event.status === DealStatusLabels[DealStatusWithSendEmail.SendEmail]) {
        <button type="button" class="btn btn-warning btn-h32" (click)="openSendWelcomeEmailDialog()">
          Send Welcome Email
        </button>
        <a
          class="cursor-pointer end-0 fs-14 h-auto text-dark wh-48"
          (click)="markDealClosedConfirmation('skip-welcome-email', $event)"
          >Skip</a
        >
      } @else if (showMarkClosedButton() && event.status === DealStatusLabels[DealStatusWithSendEmail.DealClosed]) {
        <button type="button" class="btn btn-warning btn-h32" (click)="openCloseLotModal()">Close Lot</button>
      } @else {
        <span>{{ event.status }}</span>
      }
    </div>
  }
</div>

<ng-template #closeLotModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h1 class="modal-title" ngbAutofocus tabindex="-1">Close Lot</h1>
    <span (click)="modal.dismiss()" role="button" class="ms-auto">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>
  <div class="modal-body">
    <form [formGroup]="_salesApsService.form">
      <div class="col-12">
        <span class="fw-500">Closing Date</span>
        <p-datepicker
          formControlName="closingDate"
          [showIcon]="true"
          placeholder="Select date"
          styleClass="w-100"
          clearable="false"
          dateFormat="mm/dd/yy"
          icon="pi pi-calendar"
          appendTo="body"
          [baseZIndex]="9999"
          panelStyleClass="open-above"
        />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-h45" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary btn-h45" (click)="markDealClosedConfirmation('close-lot', $event)">
      Close Lot
    </button>
  </div>
</ng-template>
